import { FileIcon } from "./FileIcon";
import { File } from "@/backend/models/file";
import { useState } from "react";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { Download, Trash2 } from "lucide-react";
import { I18n } from "@/i18n/I18n";
import { ConfirmModal } from "../modals/ConfirmModal";
import { FilePreviewModal } from "./FilePreviewModal";

export function FileCard(props: {file: File, title: string, readOnly?: boolean, onDelete?: () => Promise<unknown>}) {
  const { file, title, readOnly, onDelete } = props;
  const [showPreview, setShowPreview] = useState(false);
  const downloadFileById = useGlobalStore(state => state.downloadFileById);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDelete = async () => {
    await onDelete?.();
    setShowDeleteModal(false);
  };

  const handleClick = () => {
    if (file.isPreviewable()) {
      setShowPreview(true);
    } else {
      void downloadFileById(file);
    }
  };

  const label = file.isPreviewable() ? I18n.get('viewFileName', { fileName: file.fileName }) : I18n.get('downloadFileName', { fileName: file.fileName });

  return (  
    <>
      <div className="list-card-item previewable-file">
        <button type="button" className="previewable-file-button" onClick={handleClick} aria-label={label}>
          <FileIcon fileName={file.fileName} />
          <div className="list-card-item-info">
            <span className="list-card-item-name">{title}</span>
            <span className="list-card-item-detail">{file.fileName}</span>
          </div>
        </button>
        <div className="d-flex gap-2">
          <button className="fusa-btn-medium-icon btn-blue-light" 
            onClick={() => void downloadFileById(file)} 
            title={I18n.get('downloadFile', { fileName: file.fileName })}
            aria-label={I18n.get('downloadFile', { fileName: file.fileName })}
          >
            <Download size={20} />
          </button>
          {!readOnly && <button
              className="fusa-btn-medium-icon btn-red-light"
              onClick={() => setShowDeleteModal(true)}
              title={I18n.get('delete')}
            >
              <Trash2 size={20} />
            </button>
          }
        </div>

      </div>
      { showPreview && <FilePreviewModal file={file} onHide={() => setShowPreview(false)} /> }
      {showDeleteModal && (
        <ConfirmModal
          title={I18n.get('deleteFile')}
          confirmMessage={I18n.get('areYouSureDeleteModel', { model: I18n.get('file'), title })}
          onConfirm={() => handleDelete()}
          setShowModal={setShowDeleteModal}
        />
      )}
    </>    
  );
}
